import * as Scrivito from "scrivito";
import LinkList from "./LinkList";
import BackLink from "./BackLink";

function ThirdLevel({ currentPage, elems }) {
  return (
    <div>
      <BackLink
        containerClassNames="shadow bg-secondary"
        linkClassNames="text-dark text-light font-weight-normal p-3 btn btn-link"
      />
      <div className="nav-third pb-3">
        <strong className="text-light d-block p-3">
          {currentPage.get("title")}
        </strong>
        <LinkList
          elems={elems}
          classNameLink="text-white"
          iconSide={"left"}
          level={3}
        />
      </div>
    </div>
  );
}

export default Scrivito.connect(ThirdLevel);
